package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.Event
import com.rainbowclubs.rainbow.data.requests.AddEventCommentRequest
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class AddEventCommentUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(
        eventId: String,
        request: AddEventCommentRequest,
    ): Result<Event> {
        return eventsRepository.addEventComment(eventId, request)
    }
}
